import React from "react";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import classes from "./PrivacyPolicy.module.css";
import ReactQuill from "react-quill";
import { useState } from "react";
import { Button } from "../../Component/Button/Button";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Loader } from "../../Component/Loader";
import { apiHeader, BaseURL } from "../../config/apiUrl";
import { Get, Patch } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";

const PrivacyPolicy = () => {
  const { accessToken: accessToken } = useSelector(
    (state) => state?.authReducer
  );
  const [data, setData] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  const getPrivacyPolicy = async () => {
    const url = BaseURL(`privacy-policy/admin/all`);
    setLoading(true);
    const response = await Get(url, accessToken);
    if (response !== undefined) {
      setData(response?.data?.data?.content);
    }
    setLoading(false);
  };
  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  const handleSubmit = async () => {
    const url = BaseURL(`privacy-policy`);
    const params = {
      content: data,
    };
    for (let key in params) {
      if (params[key] == "" || params[key] == null) {
        return toast.error("Please fill the privacy policy field!");
      }
    }
    setIsSubmit(true);
    const response = await Patch(url, params, apiHeader(accessToken));
    if (response !== undefined) {
      setData(response?.data?.content);
      toast.success("Privacy Policy Updated successfully.");
    }
    setIsSubmit(false);
  };
  return (
    <SideBarSkeleton>
      <div className={classes.mainComtainer}>
        <div className={classes.header_main}>
          <h4>Privacy Policy</h4>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <ReactQuill theme="snow" value={data} onChange={setData} />
        )}
        <div className={classes.btnDiv}>
          <Button onClick={handleSubmit} disabled={isSubmit}>
            {isSubmit ? "loading..." : "Submit"}
          </Button>
        </div>
      </div>
    </SideBarSkeleton>
  );
};

export default PrivacyPolicy;
